import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ag-page_eventinsp position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_card = _resolveComponent("ag-card")!
  const _component_ag_otp_modal = _resolveComponent("ag-otp-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ag_card, {
      module: _ctx.module,
      onSearch: _ctx.search,
      onMain: _ctx.mainLink
    }, null, 8, ["module", "onSearch", "onMain"]),
    _createVNode(_component_ag_otp_modal, {
      status: _ctx.otpStatus,
      "selected-computer": _ctx.selectedComputer
    }, null, 8, ["status", "selected-computer"])
  ]))
}